import React, { useState } from "react";
import { Container, Grid } from "@mui/material";
import TextInput from "../../components/elements/TextInput.js";
import SubmitButton from "../../components/elements/SubmitButton.js";
import { enqueueSnackbar } from "../../redux/Actions.js";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { voteForIntegration } from "../../redux/Actions.js";
import { isNullOrUndefinedOrEmpty } from "../../utils.js";
import CreateNewOrganization from "../../components/forms/CreateNewOrganization.js";
import {
    ROUTES_INTEGRATIONS_LEAFLOGIX_SETUP,
    ROUTES_INTEGRATIONS_METRC_SETUP,
    ROUTES_INTEGRATIONS_ALPINEIQ_SETUP,
    ROUTES_INTEGRATIONS_IDSCAN_SETUP,
} from "../../utils/Constants.js";

import "../styles/Setup.css";

const Setup = ({subscriptions, subscriptionItems, subscriptionProducts}) => {
    const loggedInUser = useSelector(state => state.userReducer.loggedInUser.user);
    const organizations = useSelector(state => state.userReducer.loggedInUser.organizations);
    const loggedInUserIsLoading = useSelector(state => state.userReducer.loading);

    const [errors, setErrors] = useState({ "integration": "", "user_id": loggedInUser.id })
    const [formState, setFormState] = useState({ "integration": "", "user_id": loggedInUser.id });

    const dispatch = useDispatch();

    const requireOrganizations = () => {
        if (!loggedInUserIsLoading && isNullOrUndefinedOrEmpty(organizations)) {
            return <CreateNewOrganization alreadyOpen={true} />
        }
        return "";
    }

    return <>
        <div className={"main-container"}>
            {requireOrganizations()}
            <Container className="workspace">
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6} className={"left-part"}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} className="catchline">
                                <h1>Choose your integration</h1>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} className="right-part">
                        <Grid container spacing={4} className="integrator-choices">
                            <Grid item xs={0} md={2}></Grid>
                            <Grid item xs={12} md={4} className="integration-option">
                                <Link to={ROUTES_INTEGRATIONS_METRC_SETUP} id="integrations-metrc-setup">
                                    <img src={`${process.env.REACT_APP_PUBLIC_URI}/metrc.png`} alt="metrc"/>
                                </Link>
                            </Grid>
                            <Grid item xs={12} md={6} className="integration-option">
                                <Link to={ROUTES_INTEGRATIONS_ALPINEIQ_SETUP} id="integrations-alpineiq-setup">
                                    <img id="alpineiq-logo" src={`${process.env.REACT_APP_PUBLIC_URI}/alpineiq.png`} alt="AlpineIQ" />
                                </Link>
                            </Grid>
                            <Grid item xs={0} md={2}></Grid>
                            <Grid item xs={12} md={4} className="integration-option">
                                <Link to={ROUTES_INTEGRATIONS_LEAFLOGIX_SETUP} id="integrations-leaflogix-setup">
                                    <img src={`${process.env.REACT_APP_PUBLIC_URI}/leaflogix.png`} alt="Dutchie"/>
                                </Link>
                            </Grid>
                            <Grid item xs={12} md={6} className="integration-option">
                                <Link to={ROUTES_INTEGRATIONS_IDSCAN_SETUP} id="integrations-idscan-setup">
                                    <img src={`${process.env.REACT_APP_PUBLIC_URI}/idscan.png`} alt="IdScan"/>
                                </Link>
                            </Grid>
                            <Grid item xs={0} md={2}></Grid>
                            <Grid item xs={12} md={4} className="integration-option unavailable">
                                <Grid container direction="column" alignItems="center">
                                    <Grid item>
                                        <img src={`${process.env.REACT_APP_PUBLIC_URI}/blaze.png`} alt="blaze"/>
                                    </Grid>
                                    <Grid item>
                                        <p className="teaser">Coming soon</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={6} className="integration-option unavailable">
                                <Grid container direction="column" alignItems="center">
                                    <Grid item>
                                        <img src={`${process.env.REACT_APP_PUBLIC_URI}/treez-integrator.png`} alt="treez"/>
                                    </Grid>
                                    <Grid item>
                                        <p className="teaser">Coming soon</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={1} justifyItems="flex-end" justifyContent="center"
                                    alignItems="center">
                                    <Grid item xs={0} md={2}></Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextInput
                                            setErrors={setErrors}
                                            type="text"
                                            name="integration"
                                            label="Vote for an integration you don't see."
                                            formState={formState}
                                            errors={errors}
                                            setFormState={setFormState} />
                                    </Grid>
                                    <Grid item xs={12} md={2} className={"vote-submit-button"}>
                                        <SubmitButton onSubmit={(click) => {
                                            click.preventDefault();
                                            dispatch(voteForIntegration(formState)).then(resp => {
                                                dispatch(enqueueSnackbar({
                                                    message: "Vote received! Thanks for the feedback.",
                                                    options: {
                                                        variant: "success",
                                                    },
                                                }));
                                            }).catch((errs) => {
                                                dispatch(enqueueSnackbar({
                                                    message: "Vote failed. Try again later.",
                                                    options: {
                                                        variant: "error",
                                                    },
                                                }));
                                                setErrors({ ...errors, ...errs });
                                            });
                                        }}>Vote</SubmitButton>
                                    </Grid>
                                    <Grid item xs={0} md={2}></Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </div>
    </>
}


export default Setup;
